<div mat-dialog-title class="dialog-popup-header" style="display: flex; justify-content: space-between;">
    <h4 >Add Veterinarian</h4>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content style="padding: 0px 15px !important;">
    <div style="padding: 10px;">
        <label for="vetName" class="font-weight-bold">Veterinarian Name <span style="color: red;"> * </span> </label>
        <div id="vetName">
            <mat-form-field appearance="outline" style="width:100%">
                <input matInput placeholder="Veterinarian Name" [(ngModel)]="data.name" required>
            </mat-form-field>
        </div>
        <label for="vetPhone" class="font-weight-bold">Veterinarian Phone <span style="color: red;"> * </span> </label>
        <div id="vetPhone">
            <mat-form-field appearance="outline" style="width:100%">
                <input matInput placeholder="Ex. 555-555-1234" mask="(000) 000-0000" [(ngModel)]="data.phone"
                    [showMaskTyped]="true">
            </mat-form-field>
        </div>
        <label for="vetAddress" class="font-weight-bold">Veterinarian Address  </label>
        <div id="vetAddress">
            <mat-form-field appearance="outline" style="width:100%">
                <input #searchGoogleAddressInput matInput placeholder="search for location"
                required [(ngModel)]="data.displayAddress" (change)="googlePlacesSearch()" />
            </mat-form-field>
        </div>
        <label for="vetFax" class="font-weight-bold">Veterinarian Fax </label>
        <div id="vetFax">
            <mat-form-field appearance="outline" style="width:100%">
                <input matInput placeholder="Ex. 555-555-1234" mask="(000) 000-0000" [(ngModel)]="data.fax"
                    [showMaskTyped]="true">
            </mat-form-field>
        </div>
        <p *ngIf="errorMessage && errorMessage != ''" style="color:red;">{{errorMessage}}</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions style="padding:10px;float:right; margin-bottom: 0px;">
    <button mat-button mat-dialog-close mat-button style="background-color:#ff0000;color: white;">Cancel</button>
    <button mat-button style="background-color:#41A049;color: white;"
        (click)="addVet()">Save</button>
</mat-dialog-actions>